import { useState, useEffect } from 'react';

import { WORKSTATION_AUTH_STATUS } from '../../../../../services/workstationAuth';
import { PENDING_SUBSTATE } from '../constants';
import useWorkstationStatusPolling from './useWorkstationStatusPolling';

/**
 * Máquina de estados da tela de espera. Faz poll do status e reage às mudanças:
 *   - Approved → mostra a confirmação de sucesso (com botão para fazer login).
 *   - Rejected/NotFound → mostra o estado "não foi possível aprovar", de onde o
 *     Requester pode pedir aprovação novamente.
 *
 * A navegação em si (para senha ou re-cadastro) fica com o componente, via botões.
 * O poll fica ativo apenas enquanto WAITING; ao entrar em qualquer estado terminal,
 * `enabled` vira false e o hook de poll interrompe as consultas.
 */
const useWorkstationPendingFlow = () => {
  const [subState, setSubState] = useState(PENDING_SUBSTATE.WAITING);

  const { status } = useWorkstationStatusPolling({
    enabled: subState === PENDING_SUBSTATE.WAITING,
  });

  useEffect(() => {
    if (status === WORKSTATION_AUTH_STATUS.APPROVED) {
      setSubState(PENDING_SUBSTATE.SUCCESS);
    } else if (
      status === WORKSTATION_AUTH_STATUS.REJECTED ||
      status === WORKSTATION_AUTH_STATUS.NOT_FOUND
    ) {
      setSubState(PENDING_SUBSTATE.TRY_AGAIN);
    }
  }, [status]);

  return { subState };
};

export default useWorkstationPendingFlow;
